// extracted by mini-css-extract-plugin
export var box = "_4t-0";
export var check = "_4t-1";
export var checkboxButton = "_4t-6";
export var checkboxGroup = "_4t-5";
export var disabled = "_4t-7";
export var ghost = "_4t-9";
export var input = "_4t-2";
export var label = "_4t-4";
export var normal = "_4t-8";
export var uncheck = "_4t-3";